module.exports = __webpack_public_path__ + "img/gc_country_flag_jp.4862f00d.svg";